export default {
  globalConfig: {
    title: 'Global Settings',
  },
}
